import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';
import { FieldLevelAccessValue } from '@/modules/role/role.types';

export interface Properties {
  [key: string]: FieldLevelAccessValue;
}


const QUERY_KEY = 'useGetOrganizationPropertiesQueryKey';

const useGetOrganizationPropertiesQuery = (enabled = true) => {
  const { data, isLoading, isSuccess } = useQuery(
    [API_URL.ORGANIZATION_PROPERTIES_STATES, QUERY_KEY],
    () => api.get(API_URL.ORGANIZATION_PROPERTIES_STATES),
    {
      enabled,
      retry: false,
    }
  );

  return {
    overridableProperties: data?.data?.overridable_properties || null,
    properties: data?.data?.properties || null,
    isLoading,
    isSuccess,
  };
};

export default useGetOrganizationPropertiesQuery;
